class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[data-product-variant-id]');
    this.addButton = this.querySelector('[data-add-to-cart]');
    this.addButtonText = this.querySelector('[data-add-to-cart-text]');
    this.priceEl = document.querySelector(`[id="Price-${this.dataset.section}"] [data-product-price]`);
    this.compareEl = document.querySelector(`[id="Price-${this.dataset.section}"] [data-product-compare]`);

    const jsonEl = this.querySelector('[data-product-json]');
    this.product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    if (!this.form || !this.product) return;

    this.form.addEventListener('change', this.onVariantChange.bind(this));
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  getSelectedOptions() {
    return Array.from(this.querySelectorAll('fieldset[data-option-index]')).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  getVariantFromOptions(options) {
    return this.product.variants.find((variant) =>
      variant.options.every((option, index) => option === options[index])
    );
  }

  onVariantChange() {
    const options = this.getSelectedOptions();
    const variant = this.getVariantFromOptions(options);
    this.updateVariant(variant);
  }

  formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const format = (window.theme && theme.moneyFormat) || window.moneyFormat || '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {}
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  updateVariant(variant) {
    if (!variant) {
      if (this.addButton) {
        this.addButton.disabled = true;
        if (this.addButtonText) this.addButtonText.textContent = 'Unavailable';
      }
      return;
    }

    if (this.variantInput) this.variantInput.value = variant.id;

    if (this.priceEl) this.priceEl.textContent = this.formatMoney(variant.price);

    if (this.compareEl) {
      if (variant.compare_at_price > variant.price) {
        this.compareEl.hidden = false;
        this.compareEl.textContent = this.formatMoney(variant.compare_at_price);
      } else {
        this.compareEl.hidden = true;
        this.compareEl.textContent = '';
      }
    }

    if (this.addButton) {
      this.addButton.disabled = !variant.available;
      if (this.addButtonText) {
        this.addButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  onSubmit(event) {
    event.preventDefault();
    if (!this.addButton || this.addButton.disabled) return;

    this.addButton.classList.add('is-loading');
    const formData = new FormData(this.form);

    fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('addtocart'));
        if (this.addButtonText) {
          const original = this.addButtonText.textContent;
          this.addButtonText.textContent = 'Added';
          setTimeout(() => {
            this.addButtonText.textContent = original;
          }, 1200);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.addButton.classList.remove('is-loading');
      });
  }
}

customElements.define('product-form', ProductForm);
